import React, {useState} from 'react'
import { useGeneral } from '../context/general'
import styles from './CompanyDrawer.module.scss'
import Modal from '../components/Modal'
import Spinner from "../components/Spinner"
import { Divider, Skeleton, Typography, Card, CardContent, TextField, Autocomplete } from '@mui/material'

export const CompanyDrawer = ({ticker, companyName, presentedData}) => {
    const { handleCreateProjectAndOpen } = useGeneral()
    const [ modal, setModal ] = useState('')
    const handleCloseModal = () => setModal(false)

    const openProject = () => handleCreateProjectAndOpen(ticker)

    const OpenModal = () => {
        setModal('Setting up project')
    }

    return(
        <div onClick={()=>{OpenModal();openProject()}}>
            <div key={ticker} className={styles['company-data']}>
                <div>
                    <h1>{ticker}</h1>
                    <p>{companyName}</p>
                </div>
                <div className={styles['data']}>
                    {presentedData}
                </div>
            </div>
            <Modal open={!!modal} handleClose={handleCloseModal}>
                <div className="newsGraphModalContent">
                    <Spinner hasText={false} />
                    <Typography variant="h3">
                        {modal}
                    </Typography>
                </div>
            </Modal> 
        </div>
    )
}

export default CompanyDrawer